import { useEffect, useState } from 'react';
import { getContractTypesCached } from '../../../../../../services/contractType.cached';
import { ContractTypeOption } from '../atoms/ContractTypeRadio';

export const useContractTypes = () => {
  const [contractTypes, setContractTypes] = useState<ContractTypeOption[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        setIsLoading(true);
        setError(null);

        const types = await getContractTypesCached();
        const transformed: ContractTypeOption[] = types
          .filter((t) => t.is_active)
          .map((t) => ({
            value: String(t.id),
            label: t.name,
            description: t.description,
            recommended: false,
            durationValue: t.validity_duration_value,
            durationValueUnit: t.validity_duration_unit,
            orderCycleDays: t.order_cycle_days,
            uniqueRestriction: t.has_unique_restriction,
          }));

        if (alive) setContractTypes(transformed);
      } catch (e) {
        if (alive) {
          setError('Erro ao carregar tipos de contrato');
          console.error('Error fetching contract types:', e);
        }
      } finally {
        if (alive) setIsLoading(false);
      }
    })();
    return () => {
      alive = false;
    };
  }, []);

  return { contractTypes, isLoading, error };
};
